var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"social-list"},_vm._l((_vm.dataObj),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"src":item.iconUrl,"alt":""}})])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef22a4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/footer/social-list.vue
// module id = null
// module chunks = 